'use strict';

export const mainSearchBarElements = () => ({
    // latInput: document.querySelector('input[name="lat"]'),
    // lngInput: document.querySelector('input[name="lng"]'),
    // bboxInput: document.querySelector('input[name="bbox"]'),
    mainSearch: document.querySelector('form#main-search'),
    whatInput: document.querySelector('input[name="what"]'),
    whereInput: document.querySelector('input[name="where"]'),
    paymentMethodInput: document.querySelector('select[name="payment-method"]'),
    // When distance is choosable
    //distanceInput: document.querySelector('select[name="distance"]')
    distanceInput: document.querySelector('input[name="distance"]')
});